import { Row, Col } from 'antd';
import React from 'react';
import { StatusFieldOption } from 'api/tasks';
import { EmptyCell } from 'components/atoms/empty-cell/index';
import { StatusIndicator } from 'components/molecules/status-indicator';

export const ProjectStatus = ({ status }: { status: StatusFieldOption }) => {
  if (status) {
    return (
      <Row gutter={8}>
        <Col>
          <StatusIndicator status={status} progress={0} />
        </Col>
        <Col>{status.label}</Col>
      </Row>
    );
  }

  return <EmptyCell />;
};
